import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const IosAvatar = ({
  height = 21,
  width = 21,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 21 21" {...props}>
    <circle cx="10.5008" cy="8.20977" r="4.2" fill={getColor(color, isColorInherited)} />
    <path
      d="M17.3723 16.8636C15.9006 18.586 13.3297 19.7272 10.4042 19.7272C7.47865 19.7272 4.90769 18.586 3.436 16.8636C4.90769 15.1411 7.47865 14 10.4042 14C13.3297 14 15.9006 15.1411 17.3723 16.8636Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
